module.exports = __webpack_public_path__ + "img/7.25d45065.jpg";